import { Box, ListItemIcon, Typography } from "@mui/material";
import { ReactComponent as EventNotiIcon } from "assets/svg/noti-event.svg";
import { useNotificationLocalStorage } from "hooks/useNotificationLocalStorage";
import { Button } from "react-bootstrap";
import { EventAlertNotification } from "../types";
import { ContentBox, NotificationHeader, StyledListItem } from "./shared";

interface EventAlertsItemProps {
    notification: EventAlertNotification;
    organizationsMap: Map<string, string>;
    eventNamesById: Map<string, string>;
}

export const EventAlert = ({
    notification,
    organizationsMap,
    eventNamesById,
}: EventAlertsItemProps) => {
    const { isNotificationRead } = useNotificationLocalStorage();
    const resolvedEventName =
        eventNamesById.get(notification.info.eventId) ?? notification.title;

    return (
        <StyledListItem
            alignItems="flex-start"
            className={isNotificationRead(notification.id) ? "read" : "unread"}
        >
            <ListItemIcon>
                <EventNotiIcon />
            </ListItemIcon>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    width: "100%",
                }}
            >
                <NotificationHeader
                    title={notification.title}
                    orgName={
                        organizationsMap.get(notification.orgId) ||
                        notification.orgId
                    }
                    timestamp={notification.time}
                    type="Event Alert"
                />

                <ContentBox>
                    <Box
                        sx={{
                            gap: 0.5,
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <Typography variant="caption" color="#828fab">
                            {notification.message}
                        </Typography>
                        <Typography variant="caption">
                            Event Name:{" "}
                            <span style={{ color: "#828fab" }}>
                                {resolvedEventName}
                            </span>
                        </Typography>
                    </Box>
                </ContentBox>

                <Button
                    style={{ width: "fit-content", marginTop: "11px" }}
                    variant="primary"
                    href={`/event-details/${notification.info.eventId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    as="a"
                >
                    See Event Information
                </Button>
            </Box>
        </StyledListItem>
    );
};
